import React, { useState } from 'react';
import Header from '../../components/header/Header';
import profil from '../../files/profil.png';

const Accueil = () => {
  const technologies = ['React', 'Node.js', 'Express', 'MongoDB', 'REST API'];
  const [isHovered, setIsHovered] = useState(false);
  const [hoveredTag, setHoveredTag] = useState(null);

  return (
    <div className="accueil-container">
      <style>{`
        /* --- STYLES DE BASE (PC & GRAND ÉCRAN) --- */
        .accueil-container {
          display: flex;
          flex-direction: column;
          min-height: 100vh;
          width: 100%;
          margin: 0;
          padding: 0;
          box-sizing: border-box;
          background: linear-gradient(135deg, #0f2027 0%, #203a43 40%, #2c5364 75%, #1766ad 100%);
          background-color: #0f2027;
          color: #fff;
          font-family: 'Poppins', sans-serif;
          background-attachment: fixed;
          overflow-x: hidden;
        }

        .accueil-main {
          flex: 1;
          padding: 140px 20px 80px;
          max-width: 1200px;
          margin: 0 auto;
          width: 100%;
          box-sizing: border-box;
          display: grid;
          grid-template-columns: 1.2fr 0.8fr;
          align-items: center;
          gap: 50px;
          background: transparent;
        }

        .hero-content {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }

        .availability-badge {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 8px 18px;
          border-radius: 30px;
          background: rgba(255, 215, 0, 0.08);
          border: 1px solid rgba(255, 215, 0, 0.3);
          color: #ffd700;
          font-size: 14px;
          font-weight: 600;
          letter-spacing: 0.5px;
          margin-bottom: 25px;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
          backdrop-filter: blur(8px);
        }

        .pulse-dot {
          width: 8px;
          height: 8px;
          background-color: #4ade80;
          border-radius: 50%;
          box-shadow: 0 0 8px #4ade80;
          animation: pulseAnimation 2s infinite;
        }

        .hero-title {
          line-height: 1.25;
          margin: 0;
          font-weight: 800;
          font-size: clamp(1.85rem, 3.8vw, 2.4rem);
          letter-spacing: -0.5px;
          color: #ffffff;
        }

        .highlight-text {
          background: linear-gradient(90deg, #ffd700, #ffaa00);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .hero-subtitle {
          margin-top: 15px;
          margin-bottom: 10px;
          font-size: clamp(1.2rem, 2.2vw, 1.5rem);
          font-weight: 400;
          color: #e2e8f0;
        }

        .hero-description {
          margin-top: 20px;
          max-width: 680px;
          line-height: 1.8;
          color: #cbd5e1;
          font-size: clamp(0.95rem, 1.5vw, 1.05rem);
        }

        .tech-tags {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
          margin-top: 35px;
        }

        .hero-image-wrapper {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
        }

        .image-outer-circle {
          position: relative;
          width: min(380px, 75vw);
          height: min(380px, 75vw);
          border-radius: 50%;
          background: radial-gradient(circle, rgba(255, 215, 0, 0.15) 0%, transparent 70%);
          display: flex;
          justify-content: center;
          align-items: center;
          border: 1px solid rgba(255, 215, 0, 0.25);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
          backdrop-filter: blur(5px);
          animation: floatAnimation 6s ease-in-out infinite;
        }

        .hero-image {
          width: min(280px, 55vw);
          height: min(280px, 55vw);
          border-radius: 50%;
          object-fit: cover;
          border: 3px solid #ffd700;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
          transition: transform 0.4s ease, box-shadow 0.4s ease;
          cursor: pointer;
        }

        /* --- ANIMATIONS --- */
        @keyframes pulseAnimation {
          0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(74, 222, 128, 0.7); }
          70% { transform: scale(1); box-shadow: 0 0 0 8px rgba(74, 222, 128, 0); }
          100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(74, 222, 128, 0); }
        }

        @keyframes floatAnimation {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }

        /* --- ADAPTATION TABLETTE & ÉCRAN MOYEN (< 960px) --- */
        @media (max-width: 960px) {
          .accueil-main {
            grid-template-columns: 1fr;
            padding: 110px 24px 60px;
            gap: 40px;
            text-align: center;
          }

          .hero-content {
            align-items: center;
          }

          .tech-tags {
            justify-content: center;
          }

          .hero-image-wrapper {
            order: -1; /* Place la photo au-dessus du texte sur mobile/tablette */
          }

          .image-outer-circle {
            width: min(300px, 65vw);
            height: min(300px, 65vw);
          }

          .hero-image {
            width: min(220px, 48vw);
            height: min(220px, 48vw);
          }
        }

        /* --- ADAPTATION PETITS MOBILES (< 480px) --- */
        @media (max-width: 480px) {
          .accueil-main {
            padding: 90px 16px 40px;
            gap: 30px;
          }

          .availability-badge {
            font-size: 12px;
            padding: 6px 14px;
            margin-bottom: 18px;
          }

          .hero-title {
            font-size: 1.55rem;
          }

          .hero-subtitle {
            font-size: 1.15rem;
          }

          .hero-description {
            font-size: 0.92rem;
            line-height: 1.65;
          }

          .image-outer-circle {
            width: 240px;
            height: 240px;
          }

          .hero-image {
            width: 180px;
            height: 180px;
          }
        }
      `}</style>

      <Header />

      <main className="accueil-main">
        {/* Bloc Texte */}
        <div className="hero-content">
          <div className="availability-badge">
            <span className="pulse-dot" />
            Disponible pour un poste Fullstack Remote
          </div>

          <h1 className="hero-title">
            Développeur{' '}
            <span className="highlight-text"> Fullstack |  Frontend</span>, spécialisé dans la création d'applications web performantes
          </h1>

          <h2 className="hero-subtitle">
            Maheriarimanana
            <span style={{ color: '#ffd700', fontWeight: 700, marginLeft: '6px' }}>
              Rakotomanalina
            </span>
          </h2>

          <p className="hero-description">
            Je développe des applications web complètes en utilisant{' '}
            <strong style={{ color: '#ffd700', fontWeight: 600 }}>React</strong>,{' '}
            <strong style={{ color: '#ffd700', fontWeight: 600 }}>Node.js</strong>,{' '}
            <strong style={{ color: '#ffd700', fontWeight: 600 }}>Express</strong> et{' '}
            <strong style={{ color: '#ffd700', fontWeight: 600 }}>MongoDB</strong>.
            <br />
                        Je gère également{' '}
            <strong style={{ color: '#ffd700', fontWeight: 600 }}>l'hébergement des sites</strong>{' '}
            ainsi que {' '}
            <strong style={{ color: '#ffd700', fontWeight: 600 }}>les noms de domaine</strong>,{' '}
            <br />
            <br />
            Mon objectif est de transformer une idée en une solution fiable, performante et maintenable, en accordant une attention particulière à l'expérience utilisateur, à l'architecture du code et à la qualité des API.
            <br /><br />
            Actuellement à la recherche d'une opportunité en télétravail, je souhaite intégrer une équipe technique où je pourrai contribuer à des projets concrets tout en continuant à progresser auprès de développeurs expérimentés.
          </p>

          <div className="tech-tags">
            {technologies.map((tech, index) => (
              <span
                key={tech}
                style={{
                  padding: '8px 18px',
                  borderRadius: '30px',
                  background: hoveredTag === index ? 'rgba(255, 215, 0, 0.15)' : 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 215, 0, 0.25)',
                  color: '#ffd700',
                  fontSize: '14px',
                  fontWeight: 500,
                  backdropFilter: 'blur(5px)',
                  transform: hoveredTag === index ? 'translateY(-2px)' : 'translateY(0)',
                  boxShadow: hoveredTag === index ? '0 6px 18px rgba(255, 215, 0, 0.2)' : 'none',
                  transition: 'all 0.3s ease',
                  cursor: 'default',
                }}
                onMouseEnter={() => setHoveredTag(index)}
                onMouseLeave={() => setHoveredTag(null)}
              >
                {tech}
              </span>
            ))}
          </div>
        </div>

        {/* Bloc Photo */}
        <div className="hero-image-wrapper">
          <div className="image-outer-circle">
            <img
              src={profil}
              alt="Maheriarimanana Rakotomanalina"
              className="hero-image"
              style={{
                transform: isHovered ? 'scale(1.04)' : 'scale(1)',
                boxShadow: isHovered
                  ? '0 25px 50px rgba(255, 215, 0, 0.25)'
                  : '0 20px 40px rgba(0, 0, 0, 0.5)',
              }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            />
          </div>
        </div>
      </main>
    </div>
  );
};

export default Accueil;